<template>
  <ak-integration-s-f-t-p-profiles-list
    :data="service.outboundProfilesTableData.value"
    @on-create-profile="createProfileHandler"
    @on-update-profile="updateProfileHandler"
    @on-delete-profile="deleteProfileHandler"
  />
</template>

<script>
import { defineComponent } from 'vue'
import { DialogProgrammatic } from '@akerolabs/akero-vue/src/components/dialog'

import IntegrationSFTPProfilesList from './IntegrationSFTPProfilesList.vue'

export default defineComponent({
  name: 'AkIntegrationSFTPProfiles',
  components: {
    [IntegrationSFTPProfilesList.name]: IntegrationSFTPProfilesList,
  },
  props: {
    service: {
      required: true,
      type: Object,
    },
    profileService: {
      required: true,
      type: Object,
    },
  },
  setup(props) {
    /**
     * Create a new profile of the given type
     * @param {String} type
     */
    const createProfileHandler = ({ type }) =>
      props.profileService.initForNew(type)

    /**
     * Update an existing profile
     * @param {String} id
     * @returns {*}
     */
    const updateProfileHandler = ({ id }) => props.profileService.initForID(id)

    /**
     * Delete an existing profile
     * @param {String} name
     * @param {String} id
     */
    const deleteProfileHandler = ({ name, _id: id }) =>
      DialogProgrammatic.prompt({
        title: `Delete Profile`,
        message: `
          <p>
            Are you sure you want to delete ${name}?
          </p>
          <small><strong>Please type DELETE to confirm</strong></small>
        `,
        inputAttrs: {
          pattern: 'DELETE',
        },
        trapFocus: true,
        type: 'danger',
        hasIcon: true,
        size: 'small',
        confirmText: 'Yes',
        cancelText: 'No',
        onConfirm: () => props.profileService.deleteByID(id),
      })

    return {
      createProfileHandler,
      updateProfileHandler,
      deleteProfileHandler,
    }
  },
})
</script>
